<!-- <div class="block-loading app-loading">
  <div class="backdrop-loading--content app-loading" ></div>
  <img [style]="{ height: '80px', zIndex: 1111 }" alt="" src="/assets/images/loading.svg"/>
  <h3 class="loading-text">{{ 'loading.text' | translate }}</h3>
</div> -->

<div class="page_loading"></div>
